import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';

export const BodyStyleFrame = styled(animated.div)`
  padding: 8px 16px 20px 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
`;

export const BodyButton = styled.button<{ isSelected: boolean; isAvailable: boolean }>`
  background: ${({ isSelected }) => (isSelected ? COLORS.grey15 : 'inherit')};
  border: 1px solid ${COLORS.grey15};
  padding: 6px 12px;
  font-size: 16px;
  line-height: 24px;
  font-family: Audi Type;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
  gap: 12px;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
  }
  color: ${({ isAvailable, isSelected }) => {
    if (!isAvailable) return COLORS.grey30;
    if (isSelected) return COLORS.black;
    return COLORS.grey80;
  }};
`;
